import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "sm:flex-grow" }
const _hoisted_2 = { class: "py-3" }
const _hoisted_3 = { class: "bg-white shadow rounded-2xl p-8 justify-between items-start w-full h-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold py-5" }, " Talent evaluation template ")
], -1)
const _hoisted_5 = {
  key: 1,
  class: "space-y-4 flex flex-col justify-center"
}
const _hoisted_6 = { class: "w-full flex flex-row items-center space-x-5" }
const _hoisted_7 = { class: "flex flex-row w-9/12 items-center space-x-5" }
const _hoisted_8 = { class: "text-lg semibold" }
const _hoisted_9 = { class: "flex flex-row w-3/12 items-center justify-end" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 text-purple-500",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 4v16m8-8H4"
  })
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "w-full py-3 flex flex-row justify-center"
}
const _hoisted_14 = {
  key: 1,
  class: "w-full py-5 flex flex-row justify-center"
}
const _hoisted_15 = { class: "text-lg font-semibold text-primary text-center" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" No results found. try creating a evaluation from ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" here ")
const _hoisted_18 = {
  key: 2,
  class: "flex flex-col shadow-md px-10 py-10 mb-2 rounded-2xl justify-center w-full"
}
const _hoisted_19 = { class: "w-full flex flex-row items-center space-x-5" }
const _hoisted_20 = { class: "flex flex-row w-9/12 items-center space-x-5" }
const _hoisted_21 = { class: "text-lg semibold" }
const _hoisted_22 = {
  key: 0,
  class: "flex flex-row w-3/12 items-center justify-end"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 text-red-500",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              option: "card"
            }))
          : _createCommentVNode("", true),
        (!_ctx.evaluationSelected && !_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `item-card-${i + 1}`,
                  class: "flex flex-col shadow-md px-10 py-10 mb-2 rounded-2xl justify-center w-full"
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_Avatar, {
                        name: item.title
                      }, null, 8, ["name"]),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(item.title), 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => (_ctx.selectEvaluation(item, 'add'))
                      }, _hoisted_12, 8, _hoisted_10)
                    ])
                  ])
                ]))
              }), 128)),
              (_ctx.data?.length > 0 && !_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_v_pagination, {
                      modelValue: _ctx.page,
                      pages: 1,
                      "range-size": 1,
                      "active-color": "#4D00C5",
                      "onUpdate:modelValue": _ctx.updateHandler
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.data?.length <= 0 && !_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_router_link, {
                        to: "/create-talent-evaluation",
                        class: "underline"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.evaluationSelected && !_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_Avatar, {
                    name: _ctx.selectedEvaluation.title
                  }, null, 8, ["name"]),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.selectedEvaluation.title), 1)
                ]),
                (_ctx.showRemove)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectEvaluation(_ctx.item, 'remove')))
                      }, _hoisted_24)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}